import { z } from "zod";

const isoDateString = z.string().datetime({ offset: true });

export const cancelOrDeleteAccountPayloadSchema = z.object({
  customer_id: z.string().min(1),
  mode: z.enum(["cancel", "delete"]),
  effective_at: isoDateString.optional()
});

export type CancelOrDeleteAccountPayload = z.infer<typeof cancelOrDeleteAccountPayloadSchema>;
